import { render, staticRenderFns } from "./WaitEditQuestionTable.vue?vue&type=template&id=8cc3b7fc&scoped=true&"
import script from "./WaitEditQuestionTable.vue?vue&type=script&lang=js&"
export * from "./WaitEditQuestionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc3b7fc",
  null
  
)

export default component.exports